module.exports = __webpack_public_path__ + "media/images/credit_brands-ef09ad58c893af5aaea047ceb9b2b5f3.png";